export default function accountSwiper() {
  return {
    swiperEl: null,
    sliderPerViewDesktop: null,
    accountSwiperStates: {},
    init() {
      this.$nextTick(() => {
        this.initSwiperSlider();
      });
    },

    initSwiperSlider() {
      this.sliderPerViewDesktop = this.$refs.accountSwiper.getAttribute('data-slider-per-view-desktop');
      this.swiperEl = this.$refs.accountSwiper;
      const swiperParams = {
        slidesPerView: 1.15,
        spaceBetween: 10,
        navigation: {
          nextEl: this.$refs.rightArrow,
          prevEl: this.$refs.leftArrow,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          1024: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: this.sliderPerViewDesktop || 3,
          },
        },
        on: {
          slideChange: (swiper) => {
            this.accountSwiperStates[this.swiperEl.id] = {
              isLastItem: swiper.isEnd,
            };
          },
        },
      };

      Object.assign(this.swiperEl, swiperParams);
      this.swiperEl.initialize();
    },

    refreshActiveSlider() {
      // this.swiperEl.refresh();
      if (this.swiperEl && this.swiperEl.swiper) {
        this.swiperEl.swiper.slideTo(0);
      }
    },
  };
}
